<template>
    <div class="Classroom" v-loading="loading">
        <div class="Classroom_top">
            <div class="banners">
                <img src="../../../assets/img/index/law/banner1.png" alt="">
            </div>
            <div class="check_box">
                <div class="check_item" v-for="(item,index) in check_list" :key="index" >
                    <div class="check_img">
                        <img :src="item.img_src" alt="">
                    </div>
                    <div class="check_info">
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_list">
                            <div class="check_list_item" v-for="(items,indexs) in item.list" :key="indexs">{{ items.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="LAW_CLASS">
                <div class="LAW_CLASS_box">
                    <div class="LAW_CLASS_title"  @click="handle_path_video()">
                        <div class="titles">法律课堂 </div>
                        <div class="titles_en">
                            LAW CLASS 
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="LAW_CLASS_list">
                        <div class="items" v-for="(item,index) in list1" :key="index" @click="$router.push('/Classroom_list_video_detial?id='+item.id)">
                            <div class="item_imgs">
                                <!-- <img src="../../../assets/img/index/home/lsuo.png" alt=""> -->
                                <img :src="item.thumb" alt="">

                            </div>
                            <div class="item_info">
                                <div class="info_title">
                                    {{ item.title }}
                                    
                                </div>
                                <div class="item_tages">
                                    <div class="tages">
                                        <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                        {{ item.views }}
                                    </div>
                                    <div class="tages">
                                        <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                        {{ item.pub_time }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="items2"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Classroom_bom">
            <div class="LAW_CLASS_box">
                    <div class="LAW_CLASS_title"  @click="handle_path_text()">
                        <div class="titles">法律课堂 </div>
                        <div class="titles_en">
                            LAW CLASS 
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="LAW_CLASS_list">
                        <div class="items" :class="{items_bg:index==0}" v-for="(item,index) in list2" :key="index" @click="$router.push('/Classroom_list_text_detial?id='+item.id)">
                            <div class="item_no">
                                <img src="../../../assets/img/index/law/no.png" alt="">
                                <span>NO.{{ index+1 }}</span>
                            </div>
                            <div class="item_titles">
                                {{ item.title }}
                            </div>
                            <div class="item_const">
                                {{ item.desc }}
                            </div>
                            <div class="item_tages">
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                    {{ item.views }}
                                </div>
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                    {{ item.comment_num }}
                                </div>
                                <div class="tages">
                                    <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                    {{ item.pub_time }}

                                </div>
                            </div>
                        </div>
                        <div class="items2"></div>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'
 
 

export default {
    components: {
        
        
    },
    name: "homes",
    data() {
        return {
            loading:false,
            list1:[],
            list2:[],
            check_list:[]
        }
    },
    computed: {
       
    },
    watch: {
        
    },
    created() {
        this.get_type_list()
        this.get_list1()
        this.get_list2()
    },
    methods: {
        get_type_list(){
            this.loading=true
            this.$api("lessonTypeList", {
                 
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂分类',res)
                if (res.code == 1) {
                    this.check_list=res.data.splice(0,8)
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list1(){
            this.loading=true
            this.$api("lessonList", {
                 type:1,
                 limit:6,
                 recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表1',res)
                if (res.code == 1) {
                    this.list1=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list2(){
            this.loading=true
            this.$api("lessonList", {
                type:2,
                limit:9,
                recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('法律课堂列表2',res)
                if (res.code == 1) {
                    this.list2=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_path_text(item){
            this.$router.push({
                path:'/Classroom_list_text'
            })
        },
        handle_path_video(){
            this.$router.push({
                path:'/Classroom_list_video'
            })
        },
    
    },

}
</script>
<style scoped lang="less">
.Classroom{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    // padding:21px ;
    // padding-bottom: 100px;
    .Classroom_top{
        .banners{
            width: 100%;
            height: 480px;
            position: relative;
            z-index: 1;
            img{
                width: 100%;
                height: 480px;
            }
        }
        .check_box{
            width: 1440px;
            height: 258px;
            background: #FFFFFF;
            box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
            border-radius: 8px 8px 8px 8px;
            margin: auto;
            margin-top: -149px;
            position: relative;
            z-index: 2;
            padding: 40px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .check_item{
                width: 25%;
                // padding-right: 30px;
                // height: 50%;
                margin-bottom: 30px;
                display: flex;
                .check_img{
                    img{
                        width: 32px;
                    }
                }
                .check_info{
                    padding-left: 16px;
                    .check_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .check_list{
                        width: 240px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 6px;
                        .check_list_item{
                            margin-right: 24px;         
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            margin-bottom: 6px;
                        }
                    }

                }
                
            }
        }
        .LAW_CLASS{
            .LAW_CLASS_box{
                width: 1440px;
                margin: auto;
                .LAW_CLASS_title{
                   display: flex;
                   align-items: end;
                   padding-top: 56px;
                   .titles{
                       font-family: Microsoft YaHei, Microsoft YaHei;
                       font-weight: bold;
                       font-size: 36px;
                       color: #333333;
                    }
                    .titles_en{
                        font-weight: 400;
                        font-size: 24px;
                        color: rgba(55, 124, 253, 0.37);
                        margin-left: 16px;
                        img{
                            width: 24px;
                            margin-left: 20px;
                        }
                    }

                }
                .LAW_CLASS_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding-top: 40px;
                    .items{
                        width: 453px;
                        height: 390px;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                        border-radius: 8px 8px 8px 8px;
                        margin-bottom: 40px;
                        .item_imgs{
                            width: 100%;
                            height: 255px;
                            img{
                                width: 100%;
                                height: 255px;
                            }
                        }
                        .item_info{
                            padding: 20px 24px 24px 24px;
                            .info_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 20px;
                                color: #000B33;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient: vertical;
                            }
                            .item_tages{
                                display: flex;
                                align-items: center;
                                padding-top: 18px;
                                .tages{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                    margin-right: 24px;
                                    img{
                                        // width: 25px;
                                        height: 19px;
                                        margin-right: 8px;
                                    }
                                }
                            }
                        }

                    }
                    .items2{
                        width: 453px;
                    }
                }
            }
        }
    }
    .Classroom_bom{
        width: 100%;
        // height: 1053px;
        padding-bottom: 100px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 80px;
        .LAW_CLASS_box{
                width: 1440px;
                margin: auto;
                .LAW_CLASS_title{
                   display: flex;
                   align-items: end;
                   padding-top: 56px;
                   .titles{
                       font-family: Microsoft YaHei, Microsoft YaHei;
                       font-weight: bold;
                       font-size: 36px;
                       color: #333333;
                    }
                    .titles_en{
                        font-weight: 400;
                        font-size: 24px;
                        color: rgba(55, 124, 253, 0.37);
                        margin-left: 16px;
                        img{
                            width: 24px;
                            margin-left: 20px;
                        }
                    }

                }
                .LAW_CLASS_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding-top: 40px;
                    .items{ 
                        position: relative;
                        width: 453px;
                        height: 217px;
                        // background: #FFFFFF;
                        background-image: url('../../../assets/img/index/law/bg2.png');
                        background-size: 100%;
                        margin-bottom: 50px;
                        border-radius:8px 8px 8px 8px;
                        padding:24px 24px 20px 24px;
                       
                        .item_no{
                            width: 76px;
                            height: 60px;
                            position: absolute;
                            right: 30px;
                            top: -10px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #FFFFFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 76px;
                                height: 60px;
                                z-index: 1;
                            }
                            span{
                                position: relative;
                                z-index: 2;
                                margin-left: 10px;
                            }
                        }
                        .item_titles{
                            width: 300px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #333333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp:1;
                            -webkit-box-orient: vertical;

                        }
                        .item_const{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp:3;
                            -webkit-box-orient: vertical;
                            padding-top: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            // color: #FFFFFF;
                            color: #666666;
                         

                        }
                        .item_tages{
                            margin-top: 24px;
                            border-top:1px solid  #D7D7D7;
                            display: flex;
                            align-items: center;
                            padding-top: 16px;
                            .tages{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-right: 24px;
                                img{
                                    height: 19px;
                                    margin-right: 8px;
                                }
                            }
                        }


                    }
                    .items_bg{
                        background-image: url('../../../assets/img/index/law/bg1.png');
                        // background-image: none;
                        // background-color: red;
                        .item_titles{
                            color:#FFFFFF ;
                        }
                        .item_const{
                            color:#FFFFFF ;
                        }
                        .item_tages{
                            .tages{
                                color:#FFFFFF ;
                            }
                        }

                    }
                    .items2{
                        width: 453px;
                    }
                }
            }
    }
}

</style>